import { render, staticRenderFns } from "./SubfamilyArticle.vue?vue&type=template&id=2b476567&"
import script from "./SubfamilyArticle.vue?vue&type=script&lang=js&"
export * from "./SubfamilyArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports